import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition component that shows a loading animation during page navigation
 * This component listens to route changes and shows/hides the loading spinner
 */
const PageTransition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show loading spinner when route changes
    setIsLoading(true);
    
    // Hide loading spinner after a short delay to ensure smooth transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800); // Adjust timing as needed
    
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className={`loading-overlay ${isLoading ? 'active' : ''}`}>
      <div className="loading-container">
        <div className="mevedir-logo-spinner">
          <div className="logo-leaf logo-leaf-left"></div>
          <div className="logo-leaf logo-leaf-right"></div>
          <div className="logo-circle"></div>
        </div>
        <div className="loading-text">MEVEDIR</div>
      </div>
    </div>
  );
};

export default PageTransition;
